(function () {
  var SECOND = 0.6, last = '';
  function cost(t, f, b) {
    var on = [], c = 0;
    if (f) on.push(f);
    if (b) on.push(b);
    on.sort(function (x, y) { return y - x; });
    for (var i = 0; i < on.length; i++) c += t.r[on[i] - 1] * (i ? SECOND : 1);
    return c;
  }
  function paint() {
    var S = window.S, T = window.TIERS, end = document.getElementById('barEnd');
    if (!S || !T || !T.length || !end || typeof S.qty !== 'number') return;
    var p = end.querySelector('.barNudge');
    var key = S.qty + '|' + S.front + '|' + S.back;
    if (p && key === last) return;
    last = key;
    if (!p) {
      p = document.createElement('p'); p.className = 'barNudge'; p.setAttribute('aria-live', 'polite');
      var say = document.getElementById('barSay');
      if (say && say.parentNode === end) say.insertAdjacentElement('afterend', p); else end.appendChild(p);
    }
    var i = 0;
    for (var k = 0; k < T.length; k++) if (S.qty >= T[k].min && S.qty <= T[k].max) { i = k; break; }
    if (i >= T.length - 1 || (!S.front && !S.back)) { p.hidden = true; return; }
    var n = T[i + 1], save = cost(T[i], S.front, S.back) - cost(n, S.front, S.back);
    if (!(save > 0)) { p.hidden = true; return; }
    p.hidden = false;
    p.innerHTML = 'Pricing drops <b>$' + save.toFixed(2) + '</b>/piece at <button type="button" class="nudgeGo" data-q="' + n.min + '">' + n.min + ' pieces</button>';
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.barNudge .nudgeGo');
    if (!b) return;
    var q = b.getAttribute('data-q');
    var preset = document.querySelector('#keys .key[data-q="' + q + '"]');
    if (preset) { preset.click(); return; }
    var box = document.getElementById('qty');
    if (box) { box.value = q; box.dispatchEvent(new Event('input', { bubbles: true })); box.dispatchEvent(new Event('change', { bubbles: true })); }
  });
  function start() {
    var say = document.getElementById('barSay');
    if (!say) return;
    paint();
    if ('MutationObserver' in window) new MutationObserver(function () { paint(); }).observe(say, { childList: true, characterData: true, subtree: true });
    var n = 0, iv = setInterval(function () { paint(); if (++n > 40 || (window.S && window.TIERS && document.querySelector('#barEnd .barNudge'))) clearInterval(iv); }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

(function () {
  var D = String.fromCharCode(8212), W = '[ ' + String.fromCharCode(160) + ']';
  var RX = new RegExp(W + '+' + D + W + '+', 'g'), HAS = new RegExp(W + D + W);
  var SWAP = [['we reply with an itemized invoice', 'we email you the invoice']];
  function fix(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, v, i;
    while ((n = w.nextNode())) {
      v = n.nodeValue;
      if (v.indexOf(D) > -1 && HAS.test(v)) v = v.replace(RX, '; ');
      for (i = 0; i < SWAP.length; i++) if (v.indexOf(SWAP[i][0]) > -1) v = v.split(SWAP[i][0]).join(SWAP[i][1]);
      if (v !== n.nodeValue) n.nodeValue = v;
    }
  }
  window.addEventListener('beforeprint', function () {
    var sheet = document.getElementById('rvaPrint');
    if (sheet) fix(sheet);
  });
  function start() {
    var root = document.getElementById('rvaCat');
    if (!root) return;
    fix(root);
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fix(root); });
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

(function () {
  var D = String.fromCharCode(8212);
  function clean(v) {
    return String(v)
      .split('RVA THREADS ' + D + ' ORDER REQUEST').join('RVA THREADS: ORDER REQUEST')
      .split('Estimate only ' + D + ' ').join('Estimate only: ')
      .split(' ' + D + ' ').join(' - ')
      .split('we reply with an itemized invoice').join('we email you the invoice');
  }
  function wrap() {
    var f = window.requestPretty;
    if (typeof f !== 'function') return false;
    if (f.rvaClean) return true;
    var g = function () { return clean(f.apply(this, arguments)); };
    g.rvaClean = 1;
    window.requestPretty = g;
    return true;
  }
  if (!wrap()) {
    var n = 0, iv = setInterval(function () { if (wrap() || ++n > 150) clearInterval(iv); }, 100);
  }
})();